import { render, staticRenderFns } from "./EducationProgressReport.vue?vue&type=template&id=6d132682&"
import script from "./EducationProgressReport.vue?vue&type=script&lang=js&"
export * from "./EducationProgressReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports